import { useState } from 'react';
import { categoryTabs, feedItems } from '@/mocks/buzz';

export default function CategoryStream() {
  const [active, setActive] = useState('all');
  const list = active === 'all' ? feedItems : feedItems.filter((f) => f.category === active);

  return (
    <section id="browse" className="bg-surface scroll-mt-20 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="font-display text-3xl text-leaf-500 md:text-4xl">分类速览</p>
            <h2 className="mt-2 text-2xl font-black leading-snug md:text-3xl">按你口味，先挑一栏开吃</h2>
            <p className="mt-2 max-w-xl text-sm leading-6 text-ink-soft md:text-base">
              综艺、影视、明星、音乐……分类归整的速览卡片，点击标签即可快速切换栏目。
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-2">
          {categoryTabs.map((c) => {
            const isActive = active === c.id;
            return (
              <button
                key={c.id}
                onClick={() => setActive(c.id)}
                className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-bold transition-colors ${
                  isActive
                    ? 'bg-ink text-surface'
                    : 'bg-paper text-ink-soft hover:bg-coral-100 hover:text-coral-600'
                }`}
              >
                {c.icon ? <i className={`text-sm ${c.icon}`} /> : null}
                {c.label}
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((f) => (
            <article
              key={f.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-paper bg-card transition-colors hover:border-coral-200"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={f.image}
                  alt={f.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-coral-500 px-2.5 py-1 text-xs font-bold text-white">
                  {f.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="text-sm font-black leading-snug text-ink md:text-base">{f.title}</h3>
                <p className="mt-2 flex-1 text-xs leading-5 text-ink-soft md:text-sm">{f.summary}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-ink-muted">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line" /> 约{f.readTime}
                  </span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-fire-line text-coral-500" /> {f.likes}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-10 rounded-2xl bg-paper p-8 text-center text-sm text-ink-soft">
            这一栏暂时没有新内容，去看看其它栏目吧。
          </p>
        )}
      </div>
    </section>
  );
}